import { createContext, useContext } from "react";
import type { SdkServices, ServiceContextValue } from "../types/services";

export const ServicesProviderContext =
    createContext<ServiceContextValue | null>(null);

export const useServiceContext = () => {
    const context = useContext(ServicesProviderContext);

    if (!context)
        throw new Error(
            "useServiceContext must be use inside ServicesProviderContext",
        );

    return context;
};

export const useSdk = (): SdkServices => {
    const { sdk } = useServiceContext();

    if (!sdk)
        throw new Error(
            "useSdk must be used once the SDK services are created",
        );

    return sdk;
};
